import * as PageContainer from "../pages";
import { routesPaths } from "./routesPaths";

export function menuRoutes(appContextData) {
    const t = appContextData.i18n.t;
    let routes = [];

    if (t) {
        const transactions = {
            path: routesPaths.transactionsDashboard,
            name: "Transaction",
            component: PageContainer.TransactionsDashboard,
            routes: [
                {
                    path: routesPaths.transactionsDashboard,
                    name: "Search",
                    id: "cTransactions",
                    component: PageContainer.TransactionsDashboard,
                },
            ],
        };

        const paymentPage = {
            path: routesPaths.uploadPayment,
            name: "Payment",
            id: "uploadTrx",
            component: PageContainer.UploadPaymentContainer,
        };

        const creditPage = {
            path: routesPaths.uploadCredit,
            name: "Credit",
            id: "uploadCredit",
            component: PageContainer.UploadCreditContainer,
        };

        if (appContextData.enabledModules.includes("CREDIT")) {
            transactions.routes.push(creditPage);
        }
        if (appContextData.enabledModules.includes("PAY")) {
            transactions.routes.push(paymentPage);
        }

        const users = {
            path: routesPaths.usersDashboard,
            name: "Users",
            component: PageContainer.UsersDashboard,
            routes: [
                {
                    path: routesPaths.usersDashboard,
                    name: "Manage",
                    id: "cUsers",
                    component: PageContainer.UsersDashboard,
                },
                {
                    path: routesPaths.createUser,
                    name: "Add",
                    id: "addUser",
                    component: PageContainer.UserCreate,
                },
            ],
        };

        const statistic = {
            path: routesPaths.usersStatistics,
            name: "Statistic",
            component: PageContainer.UsersStatistics,
            routes: [
                {
                    path: routesPaths.usersStatistics,
                    name: "Dashboard",
                    id: "statistic",
                    component: PageContainer.UsersStatistics,
                },
            ],
        };

        const installment = {
            path: routesPaths.installment,
            name: "Installment",
            component: PageContainer.InstallmentSearch,
            routes: [
                {
                    path: routesPaths.installment,
                    name: "Search",
                    id: "search",
                    component: PageContainer.InstallmentSearch,
                },
                {
                    path: routesPaths.installmentScheduled,
                    name: "Scheduled",
                    id: "scheduled",
                    component: PageContainer.InstallmentScheduled,
                },
            ],
        };

        const routesOrder = [
            statistic.name,
            transactions.name,
            users.name,
            installment.name,
        ];

        if (
            appContextData.email.includes("francesco.barbuto@emeal.nttdata.com")
        ) {
            routes.push(statistic);
        }

        if (appContextData.enabledModules.includes("VIEW")) {
            routes.push(transactions);
        }

        if (appContextData.enabledModules.includes("INSTALLMENT")) {
            routes.push(installment);
        }

        if (appContextData.enabledModules.includes("USER")) {
            routes.push(users);
        }

        let newRoutes = routesOrder.map(
            (el) => routes.find((element) => element.name === el) || {},
        );
        routes = newRoutes.filter((value) => Object.keys(value).length !== 0);
    }

    return routes;
}

export function hiddenRoutes(appContextData) {
    const t = appContextData.i18n.t;

    if (!t) return [];

    return [
        {
            path: routesPaths.installmentDetail,
            name: "Installment Detail",
            component: PageContainer.InstallmentDetail,
            routes: [
                {
                    path: routesPaths.installmentDetail,
                    name: "Installment",
                    id: "installment",
                    component: PageContainer.InstallmentDetail,
                },
            ],
        },
        {
            path: routesPaths.splitDetail,
            name: "Split Detail",
            component: PageContainer.SplitDetail,
            routes: [
                {
                    path: routesPaths.splitDetail,
                    name: "Split Detail",
                    id: "splitDetail",
                    component: PageContainer.SplitDetail,
                },
            ],
        },
    ];
}
